import { Flex } from '@chakra-ui/react';
import { Property, PropertyList, PropertyValue } from '@main/complykit';
import { FileSyncConfig } from '@main/integrations/providers/sharepoint/services/sharepoint/handlers/file-sync/config';
import { useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  SharepointFileUrlInput,
  SharepointFileUrlInputRef,
} from '../../shared/sharepoint-file-url-input';
import { configForwardRef } from '../types';

export const ConfigSharepoint = configForwardRef<FileSyncConfig>(
  ({ orgIntegrationId, evidenceConfig, isDisabled, onDirtyChange }, ref) => {
    const { t } = useTranslation('integrations');
    const innerRef = useRef<SharepointFileUrlInputRef>(null);

    useImperativeHandle(ref, () => ({
      submit: async () => {
        const resolved = await innerRef.current?.submit();
        if (!resolved) return;
        return {
          driveId: resolved.driveId,
          fileId: resolved.fileId,
          fileName: resolved.fileName,
        };
      },
      reset: () => innerRef.current?.reset(),
    }));

    return (
      <Flex direction="column" gap={4}>
        <Flex direction="column" align="start" gap={4}>
          <PropertyList>
            <Property label={t('integrations.sharepoint.evidenceConfig.selectInput.label')}>
              <PropertyValue
                placeholder={t('integrations.sharepoint.evidenceConfig.selectInput.placeholder')}
              >
                {evidenceConfig?.fileName}
              </PropertyValue>
            </Property>
          </PropertyList>
          <SharepointFileUrlInput
            ref={innerRef}
            orgIntegrationId={orgIntegrationId}
            isDisabled={isDisabled}
            onDirtyChange={onDirtyChange}
          />
        </Flex>
      </Flex>
    );
  },
);
